module.exports = __webpack_public_path__ + "static/media/edu_game.73378050.mp4";